// Module
var code = "<div> <ul ng-transclude class=\"qpui-breadcrumb-container\"></ul> </div>";
// Exports
export default code;